import { httpClient } from '@/network/clientController'

/** Get Favorites Tabs
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_favoritestabs
*/
export const getFavoritesTabs = () => {
    return httpClient({
		method: 'GET',
		url: 'favorites/tabs',
		isCancellable: true
	})
}

/** Get List of favorites
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_favoriteslist
*/
export const getFavoritesList = (payload) => {
    return httpClient({
		method: 'GET',
		url: 'favorites/list',
        params: payload,
		isCancellable: true
	})
}

/** Add Favorite
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_favorites
*/
export const addFavorite = (payload) => {
	return httpClient({
		method: 'POST',
		url: 'favorites',
		data: payload
	})
}

/** Remove Favorite
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/DELETE_favorites%7Bid%7D
*/
export const removeFavorite = (payload) => {
	return httpClient({
		method: 'DELETE',
		url: `favorites/${payload}`
	})
}

/** Edit Favorite
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/PUT_favorites
*/
export const editFavorite = (payload) => {
	return httpClient({
		method: 'PUT',
		url: 'favorites',
		data: payload
	})
}
